import { render, staticRenderFns } from "./LogisticsCreate.vue?vue&type=template&id=5eb43dae&"
import script from "./LogisticsCreate.vue?vue&type=script&lang=js&"
export * from "./LogisticsCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports